var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaritialIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37061 14.3574C11.6775 14.3574 13.5476 12.4866 13.5476 10.1787C13.5476 7.87088 11.6775 6 9.37061 6C7.06371 6 5.1936 7.87088 5.1936 10.1787C5.1936 12.4866 7.06371 14.3574 9.37061 14.3574Z",
    fill: "#6D57DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1113 14.3574C22.4182 14.3574 24.2883 12.4866 24.2883 10.1787C24.2883 7.87088 22.4182 6 20.1113 6C17.8044 6 15.9343 7.87088 15.9343 10.1787C15.9343 12.4866 17.8044 14.3574 20.1113 14.3574Z",
    fill: "#6D57DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38686 15.5514H12.354C12.987 15.5514 13.5941 15.8029 14.0418 16.2507C14.4894 16.6986 14.7409 17.3059 14.7409 17.9392V22.7149H4V17.9392C4 17.3059 4.25147 16.6986 4.69909 16.2507C5.14672 15.8029 5.75382 15.5514 6.38686 15.5514V15.5514Z",
    fill: "#6D57DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1077 15.919C19.2157 15.751 19.3643 15.6127 19.5396 15.517C19.715 15.4212 19.9116 15.3711 20.1113 15.3711C20.3111 15.3711 20.5077 15.4212 20.683 15.517C20.8584 15.6127 21.0069 15.751 21.115 15.919L24.3003 20.875C24.4163 21.0554 24.4816 21.2638 24.4892 21.4782C24.4969 21.6926 24.4467 21.9051 24.3439 22.0934C24.241 22.2817 24.0894 22.4387 23.9049 22.5481C23.7204 22.6574 23.5099 22.715 23.2954 22.7148H16.9273C16.7128 22.715 16.5023 22.6574 16.3178 22.5481C16.1333 22.4387 15.9816 22.2817 15.8788 22.0934C15.776 21.9051 15.7258 21.6926 15.7334 21.4782C15.7411 21.2638 15.8064 21.0554 15.9224 20.875L19.1077 15.919Z",
    fill: "#6D57DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaritialIcon);
export default __webpack_public_path__ + "static/media/Maritial_Icon.571e7b79e21fa582b03368e1384ff775.svg";
export { ForwardRef as ReactComponent };